import { render, staticRenderFns } from "./WarehouseDetailParcels.vue?vue&type=template&id=d5fa2114&scoped=true&"
import script from "./WarehouseDetailParcels.vue?vue&type=script&lang=js&"
export * from "./WarehouseDetailParcels.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseDetailParcels.vue?vue&type=style&index=0&id=d5fa2114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5fa2114",
  null
  
)

export default component.exports